import React, { memo, useEffect, useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import withClientOnlyRender from "@/hocs/withClientOnlyRender";
import {
  useLanguage,
  useRouteSlug,
  useCurrency,
  useIsLoggedIn,
  useCountryId
} from "@/hooks";

import { LoyaltyPointsService } from "@/services";

import { fetchLoyaltyDetails } from "@/redux/actions/myAccount.action";

import { getLoyaltyBody } from "@/util/loyalty-points";
import {
  selectAccessToken,
  selectIsCheckedLoyaltyProgram,
  selectStaticAssets
} from "@/util/selectors";
import { useAppSelector } from "@/redux/store";
import { selectProductDetails } from "../selectors";
import loyaltyPointsStarSrc from "../../../images/loyaltyPointsStar.png";

import "./style.scss";

const LoyaltyPointsInfo = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loyaltyPoints, setLoyaltyPoints] = useState<number>();

  const accessToken = useSelector(selectAccessToken);
  const isCheckedLoyaltyProgram = useSelector(selectIsCheckedLoyaltyProgram);
  const product = useSelector(selectProductDetails);

  const currency = useCurrency();
  const countryId = useCountryId();
  const language = useLanguage();
  const routeSlug = useRouteSlug();
  const isLoggedIn = useIsLoggedIn();
  const staticAssets = useAppSelector(selectStaticAssets);

  const dispatch = useDispatch();
  const { t } = useTranslation("productDetails");
  const tierToken = useSelector(
    (state: any) => state.myAccountReducer?.tierToken
  );

  useEffect(() => {
    const loadPoints = async () => {
      const isJoined = !!(
        isLoggedIn &&
        (tierToken ||
          (!isCheckedLoyaltyProgram &&
            ((await dispatch(fetchLoyaltyDetails(language))) as any)))
      );
      if (isJoined) {
        const { orderItems } = getLoyaltyBody({ cart: [product] });
        const points = await LoyaltyPointsService.getLoyaltyPointsByCart(
          orderItems,
          "pdp"
        );
        setLoyaltyPoints(points);
      }

      setIsLoaded(true);
    };

    if (isLoggedIn) {
      loadPoints();
    } else {
      setIsLoaded(true);
    }
  }, [isLoggedIn, tierToken, product, isCheckedLoyaltyProgram]);

  if (!isLoaded) return null;

  return (
    <div className="loyalty_pdp_wrap">
      <div className="loyalty_pdp_content">
        <img
          src={loyaltyPointsStarSrc}
          alt="loyalty program gift icon"
          width={17}
        />
        <p className="earnPoints">
          {accessToken && isLoggedIn && (
            <>{t("youWillEarnUpTo", { loyaltyPoints })} </>
          )}

          {!isLoggedIn && <>{t("dontMissOutLoyalty")}</>}
        </p>
      </div>
      {accessToken && isLoggedIn && (
        <Link
          className="learn-more-btn"
          to={`/${routeSlug}${staticAssets?.loyaltyProgramSlug}`}
        >
          {t("learnMore")}
        </Link>
      )}

      {!isLoggedIn && (
        <Link
          className="learn-more-btn"
          to={{
            pathname: `/${routeSlug}/authorization/`,
            search: `?redirect=${product.url}`
          }}
        >
          {t("joinNow")}
        </Link>
      )}
    </div>
  );
};

export default memo(withClientOnlyRender(LoyaltyPointsInfo));
